module.exports = "<div [innerHTML]=\"cartao | safe: 'html'\"></div>\r\n"